import { useCallback, useEffect, useState } from 'react';
import { getProductPrice } from '@/services/payment/payment.service';
import { Price, Product } from '@/core/models';

const useProductPrice = () => {
   const [product, setProduct] = useState<Product | null>(null);
   const [price, setPrice] = useState<number | null>(null);
   const [renewalPrice, setRenewalPrice] = useState<Price | null>(null);
   const [renewalPriceAmount, setRenewalPriceAmount] = useState<number | null>(null);

   const fetchProduct = useCallback(async () => {
      const [error, data] = await getProductPrice();

      if (error) {
         console.log(error);
         setProduct(null);
         return;
      }

      setProduct(data.response);
      setPrice(data.response.priceDetails.amount / 100);
      setRenewalPrice(data.response.allPrices.find(p => p.lookupKey === 'card_renewal') || null);
      setRenewalPriceAmount(
         (data.response.allPrices.find(p => p.lookupKey === 'card_renewal')?.amount as number) / 100 || null,
      );
   }, []);

   useEffect(() => {
      fetchProduct();
   }, [fetchProduct]);

   return { product, price, setPrice, renewalPrice, renewalPriceAmount, setRenewalPriceAmount };
};

export default useProductPrice;
